export default () => ({
  type: Shopify.country === "US" ? "us" : "eu",

  setType(type) {
    this.type = type;
  },
});
